import React from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';
import _ from 'lodash';
import StringConstant from '../../constants/StringConstants';
import { Radio as RadioButton } from 'react-bootstrap';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import MoveMoneyBL from './MoveMoneyBL';

// TODO: It can be merged with SavingPotCOmponent
class SavingPotAvailable extends React.Component {
  constructor(props) {
    super(props);
    this.totalClick = this.totalClick.bind(this);
  }

  totalClick(e) {
    this.props.onClick(this.props.data);
  }

  render() {
    const id = `tot-${this.props.data.id} ${this.props.name}`;
    // TOCHECK: IS current balance or available balanace
    let availableBalance = MoveMoneyBL.currentAmount(this.props.data, false);
    const availableAmt = NumberUtils.appendCurrency('{}', availableBalance);
    let disabled = false;
    let checked = false;
    if (this.props.name === StringConstant.fromList) {
      // need to move below conditions to BL if  its working
      disabled = availableBalance === 0;
      if (
        (MoveMoneyStore.isOneOffPayment() ||
          !_.isEmpty(MoveMoneyStore.isOnlyMoveMoney())) &&
        !MoveMoneyStore.getOneOffPayment().isMonthly &&
        !_.isEmpty(MoveMoneyStore.getSelectedToAccount()) &&
        this.props.data.id === MoveMoneyStore.getSelectedToAccount().id
      ) {
        disabled = true;
      }
      if (
        !_.isEmpty(MoveMoneyStore.getSelectedAccount()) &&
        MoveMoneyStore.getSelectedAccount().id === this.props.data.id &&
        _.isEmpty(MoveMoneyStore.getSelectedFromPot())
      ) {
        checked = true;
      }
    } else if (
      !_.isEmpty(MoveMoneyStore.getSelectedToAccount()) &&
      MoveMoneyStore.getSelectedToAccount().id === this.props.data.id &&
      _.isEmpty(MoveMoneyStore.getSelectedToPot())
    ) {
      checked = true;
    }
    return (
      <RadioButton
        id={id}
        name={'radioGroupVertical'}
        className="c-radio__vertical"
        value={availableBalance}
        onClick={this.totalClick}
        defaultChecked={checked}
        disabled={disabled}
      >
        <label htmlFor={id} className="c-radio__label c-radio__label--border">
          <span className="c-radio__label--wrap">
            <h6 className="text pot-name pull-left">Available balance</h6>
            <h6 className="text pull-right">{availableAmt}</h6>
          </span>
        </label>
      </RadioButton>
    );
  }
}

SavingPotAvailable.propTypes = {
  onClick: PropTypes.func,
  data: PropTypes.object,
  name: PropTypes.string,
};

SavingPotAvailable.defaultProps = {
  data: {},
  name: '',
};
export default SavingPotAvailable;
